angular.module('natgeo').factory('CommonFunctions', 
function CommonFunctions() 
{
  var CommonFunctions = 
  {

    /**
     * Quickly apply changes without animations.
     */
    quickApply: function(screen, $scope)
    {
      var animated = screen.view.find('.ng-show-animate');

      animated.removeClass('ng-show-animate');

      $scope.$apply();

      animated.addClass('ng-show-animate');
    },

    /**
     * 'Shuffles' a set of jQuery elements by randomly swapping
     * data-top and data-left attribute values.
     */
    shuffleElements: function(elements, container)
    {
      elements.scale( container.getScale() );

      for (var i = 0; i < elements.length; i++)
      {
        var k = Math.floor( Math.random() * elements.length );

        if (k !== i)
        {
          var a = elements.eq( i );
          var b = elements.eq( k );
          var top = a.data('top');
          var left = a.data('left');

          a.data('top', b.data('top'));
          a.data('left', b.data('left'));
          b.data('top', top);
          b.data('left', left);
        }
      }

      elements.scale( container.getScale() );
    },

    /**
     * Given a text & box sprite this generates a function that can set the HTML
     * on the text sprite - and if the HTML is different it animates the sprites.
     */
    setHelperText: function($text, $box)
    {
      var previousText = false;

      return function(text)
      {
        if ( previousText !== text )
        {
          previousText = text;

          $text
            .stopIt()
            .play('fadeOut 0.5s')
            .animators()
            .once('finished', function() {
              $text.html( previousText );
              $text.play('zoomIn 0.7s');
            })
          ;

          $box
            .stopIt()
            .play('fadeOut 0.5s')
            .animators()
            .once('finished', function() {
              $box.play('zoomIn 0.7s');
            })
          ;
        }
        else
        {
          $text.play('pulse 0.5s');
          $box.play('pulse 0.5s');
        }
      };
    },

    /**
     * Initializes the draggables on the given screen for robot building.
     */
    initializeDraggable: function(screen)
    {
      screen.view
        .find('.draggable')
        .draggable(
        {
          distance: 3,
          revert: function(droppable)
          {
            var part = $(this);

            if ( part.hasClass('dropped') )
            {
              return false;
            }
            if ( droppable === false)
            {
              screen.setHelperText('Try again.'); 

              return true;
            }
            else if ( !part.hasClass( droppable.data( 'accept' ) ) )
            {
              screen.setHelperText('Try another location on the robot.'); 

              return true;
            }

            return false;
          },
          containment: screen.view
        })
      ;
    },

    /**
     * Initializes the droppables on the given screen for robot building.
     */
    initializeDroppable: function(screen)
    {
      screen.view
        .find('.droppable')
        .each(function() 
        {
          var accepting = $(this).data('accept');

          $(this).droppable(
          {
            drop: function(event, ui) 
            {
              var part = ui.draggable;

              if ( part.hasClass( accepting ) )
              {
                part.addClass('dropped');

                screen.onPartDrop( part );
            
                if ( ++screen.dropCount === screen.dropMax )
                {
                  screen.onLastPart();
                }
              }
            }
          });
        })
      ;
    },

    /**
     * Sets up the given scope for submarines based on the users selections.
     */
    setupSubmarineFunctions: function($scope, UserProgress)
    {
      // Do they have the cylinder body type selected?
      $scope.isCylinder = function()
      {
        return UserProgress.SubmarineBody === UserProgress.SubmarineBodies.Cylinder;
      };

      // Do they have the cylinder body type selected?
      $scope.isRectangle = function()
      {
        return UserProgress.SubmarineBody === UserProgress.SubmarineBodies.Rectangle;
      };

      // Do they have the propeller motor selected?
      $scope.isPropeller = function()
      {
        return UserProgress.SubmarineMotor === UserProgress.SubmarineMotors.Propeller;
      };

      // Do they have the hybrid motor selected?
      $scope.isHybrid = function()
      {
        return UserProgress.SubmarineMotor === UserProgress.SubmarineMotors.Hybrid;
      };

      // Do they have the sonar sensor selected?
      $scope.isSonar = function()
      {
        return UserProgress.SubmarineSensor === UserProgress.SubmarineSensors.Sonar;
      };

      // Do they have the camera sensor selected?
      $scope.isCamera = function()
      {
        return UserProgress.SubmarineSensor === UserProgress.SubmarineSensors.Camera;
      };

      // Do they have the magnet effector selected?
      $scope.isMagnet = function()
      {
        return UserProgress.SubmarineEffector === UserProgress.SubmarineEffectors.Magnet;
      };

      // Do they have the robotic arm effector selected?
      $scope.isArm = function()
      {
        return UserProgress.SubmarineEffector === UserProgress.SubmarineEffectors.Arm;
      };

      // Do they have the micro-net effector selected?
      $scope.isNet = function()
      {
        return UserProgress.SubmarineEffector === UserProgress.SubmarineEffectors.Net;
      };
    },

    /**
     * Shows the given help pop-up by playing it's data-show animation and
     * playing it's children's data-displayed animations.
     */
    showHelp: function(help, onshow, zIndex)
    {
      if ( help )
      {
        help
          .css( 'zIndex', anim8.coalesce( zIndex, 300 ) )
          .removeClass('hidden')
          .restore()
          .dataPlay('show')
          .applyInitialState()
          .animators()
          .once('finished', function()
          {
            if ( anim8.isFunction( onshow ) )
            {
              onshow.apply( help );
            }
          })
        ;
        
        help
          .find('[data-displayed]')
          .dataPlay('displayed')
          .applyInitialState()
        ;
      }
    },
    
    /**
     * Hides the given help pop-up by playing it's data-hide animation and
     * stopping it's childrens animaitions.
     */
    hideHelp: function(help, onhide)
    {
      if ( help )
      {
        help
          .dataPlay('hide')
          .applyInitialState()
          .animators()
          .once('finished', function() {
            help
              .addClass('hidden')
              .css('zIndex', '')
              .find('[data-displayed]')
              .stopIt()
            ;

            if ( anim8.isFunction( onhide ) )
            {
              onhide.apply( help );
            }
          })
        ;
      }
    },

    /**
     * Generates a help function given a screen and the name of the next button to display
     * after the user selects the first help pop-up. If an invalid/no helpName is given then
     * the current help pop-up is closed.
     */
    help: function(screen, nextName, zIndex)
    {
      var currentHelp = null;

      return function( helpName, helpButtonName, keepNextHidden )
      {
        var next = screen.sprite( nextName );
        var helpButton = screen.sprite( helpButtonName );
        var nextHelp = screen.sprite( helpName );
        var prevHelp = currentHelp;
        
        if ( nextHelp === prevHelp )
        {
          return;
        }
        
        currentHelp = nextHelp;
        
        CommonFunctions.showHelp( nextHelp, undefined, zIndex );
        CommonFunctions.hideHelp( prevHelp );

        if ( next && next.hasClass( 'hidden' ) && !keepNextHidden )
        {
          screen.introduce( nextName, 'nextIn' );
        }

        if ( helpButton )
        {
          helpButton.stopIt().restore();
        }
      };
    },

    /**
     * Initializes a command drag-and-drop interface for the given screen.
     */
    initializeCommandInterface: function(screen, container, ColorizeFactory, UserProgress, SoundEngine)
    {
      screen.slots = screen.sprites.filter('.droppable');
      screen.commandTemplates = screen.sprites.filter('.draggable'); 
      screen.activeSlot = false;
      
      // Array of commands.
      screen.commands = new Array( screen.slots.length );
      screen.commands.last = function() {
        return this[ this.count() - 1 ];
      };
      screen.commands.count = function() {
        for (var i = 0; i < this.length; i++) {
          if (!this[i]) {
            return i;
          }
        }
        return this.length;
      };
      
      // A single command on the screen placed in a slot
      function Command(template, element)
      {
        this.highlight = screen.sprite( template.data('highlight') );
        this.template = template;
        this.element = element;
        this.index = -1;
        this.slotted = false;
        this.element.data( 'instance', this );
      }
      
      Command.prototype = 
      {
        // Dropped off the slot tray
        destroy: function( dontAnimate ) 
        {
          this.unplace();

          if ( dontAnimate )
          {
            this.remove();
          }
          else
          {
            this.element
              .play('blurOut 0.5s')
              .applyInitialState()
              .animators()
              .once('finished', this.remove, this);
            ;
          }
        },
        // remove from screen
        remove: function() 
        {
          this.element.remove();
        },
        // remove from slot tray
        unplace: function() 
        {
          if (this.index !== -1) {
            screen.commands[ this.index ] = null;
            this.index = -1;  
          }
        },
        // get the bounds og the given jQuery element.
        getRect: function($e) 
        {
          return {
            left: $e.data('left'),
            top: $e.data('top')
          };
        },
        // Place this command on the given slot
        place: function(slot, fromTemplate, currentPosition) 
        { 
          var element = this.element;
          var data = $.extend( {}, slot.data() );
          
          var slotRect = this.getRect( slot );
          var commandRect = this.getRect( element );
          var templateRect = this.getRect( this.template );
          
          var start = fromTemplate ? templateRect : commandRect;
          var end = slotRect;
          
          var animate = !element.is('.ui-draggable-dragging');
          
          if ( animate && currentPosition ) 
          {
            start.left = currentPosition.left;
            start.top = currentPosition.top;
          }
          
          element.data( data );
          element.scale( container.getScale() );
          
          this.back();
          
          this.index = slot.data('index');
          screen.commands[ this.index ] = this;
          
          if ( !animate ) 
          {
            return;
          }
          
          var animation = {
            keyframe: {
              from: {
                translateX: (start.left - end.left) * container.getScale(),
                translateY: (start.top - end.top) * container.getScale()
              },
              to: {
                translateX: 0,
                translateY: 0
              }
            }
          };
          var animationOptions = {
            duration: 300
          };
          
          anim8( element[0] )
            .play( animation, animationOptions )
            .applyInitialState()
          ;
        },
        front: function() 
        {
          this.element.css('zIndex', 100);
        },
        back: function() 
        {
          this.element.css('zIndex', 50);
        }
      };
      
      screen.once('introBefore', function()
      { 
        // Animations
        anim8.save('scaleUp', {
          keyframe: {
            from: { scale: 1.0 },
            to:   { scale: 1.2 }
          },
          durations: {
            scale: 300
          }
        });
        anim8.save('scaleDown', {
          keyframe: {
            from: { scale: 1.2 },
            to:   { scale: 1.0 }
          },
          durations: {
            scale: 300
          }
        });

        // Draggables
        screen.commandTemplates.draggable(
        {
          distance: 3,
          containment: screen.view,
          revert: 'invalid',
          scroll: false,
          helper: 'clone',
          start: function(e, ui)
          {
            $(ui.helper).css('zIndex', 100);
            $(ui.helper).removeAttr('anim8').play('scaleUp');
          },
          stop: function(e, ui)
          {
            $(ui.helper).removeAttr('anim8').play('scaleDown');
          }
        });
        
        // Droppables
        screen.slots.droppable(
        {
          // Accept a draggable if it already has an instance OR the last slot is not filled.
          accept: function(command)
          {
            return command.data('instance') || screen.commands.length !== screen.commands.count();
          },
          drop: function(event, ui)
          {       
            var slot = screen.findSlot( $(this) );
            var command = ui.draggable;
                    
            if ( slot )
            {
              if ( !command.data('instance') )
              {
                screen.onNewCommandDrop( command, slot, false, ui.position );
              }
              else
              {
                screen.onExistingCommandDrop( command, slot );
              }
            }
            
            screen.deactivateSlot();

            return !!slot;
          },
          over: function(event, ui)
          {
            var slot = $(this);
            
            screen.makeRoom( slot );
            
            var dropSlot = screen.findSlot( slot );
            
            if ( dropSlot )
            {
              screen.deactivateSlot();
              screen.activeSlot = dropSlot;
              screen.activeSlot.play('pulse infinite');
            }
          },
          out: function(event, ui)
          {
            screen.deactivateSlot();
          }
        });
        
        // Initialize slots with their index
        screen.slots.each(function(i)
        {
          $(this).data( 'index', i );
        });
      });
      
      // When they enter the screen update the color of the body
      screen.on('introBefore', function()
      {
        // Reset Waves
        screen.currentWave = 0;
        screen.currentWaveVariation = 0;

        // Show hideOnComplete elements
        screen.view.find('.hideOnComplete').removeClass('hidden');

        // Hide the following sprites in the event they are visiting this screen for the second+ time.
        screen.hideSprite( 'leftHighlight' );
        screen.hideSprite( 'rightHighlight' );
        screen.hideSprite( 'forwardHighlight' );
        screen.hideSprite( 'next' );
        screen.hideSprite( 'prev' );
        screen.hideSprite( 'encourage' );
        screen.hideSprite( 'description0', true );
        screen.hideSprite( 'description1' );
        screen.hideSprite( 'description2' );
        screen.hideSprite( 'congrats' );
        screen.hideSprite( 'go', true );
        screen.hideSprite( 'dontgo' );

        // Destroy any existing commands.
        screen.destroyCommands( true );

        // Destroy existing
        screen.view.find('.obstacle').remove();
        screen.view.find('.target').remove();

        // Start the first wave!
        screen.setupWave();
      });

      // When the intro begins...
      screen.on('introBegin', function()
      {
        // Colorize that robot!
        if ( ColorizeFactory )
        {
          if ( !screen.robotBodyColorizer )
          {
            screen.robotBodyColorizer = ColorizeFactory( screen._robotBody );
          }

          screen.robotBodyColorizer.setColor( UserProgress.Colors.Gray, UserProgress.CurrentBodyColor() ); 
        }
      });

      // Key Input
      screen.on('introEnd', function()
      {
        Shortcuts.down( { key: Shortcuts.keys.Up }, screen.addForward );
        Shortcuts.down( { key: Shortcuts.keys.Left }, screen.addLeft );
        Shortcuts.down( { key: Shortcuts.keys.Right }, screen.addRight );
        Shortcuts.down( { key: Shortcuts.keys.Enter }, screen.onEnter );
        Shortcuts.down( { key: Shortcuts.keys.Escape }, screen.destroyCommands );
        Shortcuts.down( { key: Shortcuts.keys.Backspace }, screen.destroyLast );
        Shortcuts.down( { key: Shortcuts.keys.Delete }, screen.destroyLast );
      });
      screen.on('outroBegin', function()
      {
        Shortcuts.off();
      });
      screen.addForward = function()
      {
        screen._forward.click();
      };
      screen.addLeft = function()
      {
        screen._left.click();
      };
      screen.addRight = function()
      {
        screen._right.click();
      };
      screen.destroyLast = function()
      {
        var last = screen.commands.last();
        if ( last )
        {
          last.destroy();

          SoundEngine.play( 'com-2' );
        }
      };

      // Hides the sprite with the given name.
      screen.hideSprite = function(nm, show)
      {
        var sprite = screen.sprite( nm );

        if ( sprite )
        {
          sprite.toggleClass('hidden', !show);
        }
      };  
      
      // When they click on a command add that command to the last slot
      screen.commandTemplates.click(function()
      {
        var last = screen.getLastOpenSlot();
        
        if ( last !== false )
        {
          screen.onNewCommandDrop( $(this), last, true );
        }
      });
      
      // When the active pulsing slot should be off
      screen.deactivateSlot = function()
      {
        if ( screen.activeSlot )
        {
          screen.activeSlot.restore();
          screen.activeSlot.stopIt();
          screen.activeSlot = false;
        }
      };
      
      // When a new command has been dropped on the screen
      screen.onNewCommandDrop = function(commandTemplate, slot, fromTemplate, currentPosition)
      {
        var command = commandTemplate.clone();
        var instance = new Command( commandTemplate, command );
        
        command
          .appendTo( screen.view )
          .removeAttr('anim8')
          .play( 'bounceIn 0.5s' )
          .draggable(
          {
            distance: 3,
            containment: container.$screen,
            scroll: false,
            revert: function(dropped)
            {
              if ( !dropped )
              {
                instance.destroy();
                screen.compressCommands();
                screen.deactivateSlot();

                SoundEngine.play( 'com-2' );
              }
              
              return false;
            },
            start: function(e, ui)
            {
              instance.front();
              instance.unplace();

              anim8( ui.helper ).removeA
              command.animators().play('scaleUp');
            },
            stop: function()
            {
              command.animators().play('scaleDown');  
            }
          })
        ; 
        
        instance.place( slot, fromTemplate, currentPosition );
        instance.back();

        SoundEngine.play( 'com-1' );
      };
      
      // When a command has been moved to another slot
      screen.onExistingCommandDrop = function(command, slot)
      {
        var instance = command.data('instance');
        
        instance.place( slot, false );
        instance.back();

        command.play( 'bounceIn 0.5s' );
      };
      
      // Finds an open slot based on the given slot
      screen.findSlot = function(slot)
      {
        var slotIndex = slot.data('index');
        
        // If the slot doesn't have a command...
        if ( !screen.commands[slotIndex] )
        {
          // If there are only commands to the left... it's a fine choice!
          var filled = true;
          for (var i = 0; i < slotIndex; i++)
          {
            filled = filled && screen.commands[i]
          }
          if (filled)
          {
            return slot;
          }
        }
        
        // Find the last open slot...
        return screen.getLastOpenSlot();
      };
      
      // Rearranges commands in slots while animating them
      screen.makeRoom = function(slot)
      {   
        var slotIndex = slot.data('index');
        
        // Move commands to the left (when you're dragging a command to the right)
        for (var i = 0; i < slotIndex; i++)
        {     
          if ( !screen.commands[i] )
          {
            var next = screen.findSlottedCommand( i, 1, screen.slots.length );
          
            if ( next )
            {
              screen.moveCommand( next, i );
            }
          }
        }
        
        // If the slot has a command, move the commands in the slots to the right one more
        if ( screen.commands[slotIndex] )
        {
          var pushCommand = function(index)
          {
            var next = index + 1;
            var hasNext = next < Math.min( screen.commands.count() + 1, screen.commands.length );
            
            if ( hasNext )
            {
              pushCommand( next );

              if ( screen.commands[ index ] && !screen.commands[ next ] )
              {
                screen.moveCommand( index, next );  
              }
            }
          };
          
          pushCommand( slotIndex );
        }
      };
      
      // When a command that was over a slot is no longer on any slots, squish the commands
      screen.compressCommands = function()
      {   
        var last = screen.commands.length - 1;
        
        for (var i = 0; i < last; i++)
        {
          var next = screen.findSlottedCommand( i + 1, 1, screen.commands.length );
          
          if ( !screen.commands[ i ] && next !== false )
          {
            screen.moveCommand( next, i );
          }
        }
      };
      
      // Returns the last open slot or returns false if none exist
      screen.getLastOpenSlot = function()
      {
        var last = screen.commands.length - 1;
        
        for (var i = last; i >= 0; i--)
        {     
          if ( screen.commands[ i ] )
          {
            return i === last ? false : screen.slots.eq( i + 1 );
          }
        }
        
        return screen.slots.eq( 0 );
      };
      
      // Searches for a command in the slots starting at the index and going in the given direction before it 
      // hits the given max
      screen.findSlottedCommand = function(start, direction, max)
      {
        while (start != max)
        {
          if ( screen.commands[start] )
          {
            return start;
          }
          
          start += direction;
        }
        
        return false;
      };

      // Moves the command from one slot to another
      screen.moveCommand = function(currentSlot, nextSlot)
      {
        if ( screen.commands[ nextSlot ] )
        {
          return false;
        }
        
        screen.commands[ currentSlot ].place( screen.slots.eq( nextSlot ), false );
        screen.commands[ nextSlot ] = screen.commands[ currentSlot ];
        screen.commands[ currentSlot ] = null;
      };

      // Places the object on the given cell
      screen.placeItem = function(item, column, row)
      {
        item
          .scale( container.getScale() )
          .data( 'left', screen.gridCorner.x + screen.gridSize * column )
          .data( 'top',  screen.gridCorner.y + screen.gridSize * row )
          .scale( container.getScale() )
          .find('[data-rect]')
            .scale( container.getScale() )
        ;

        return item;
      };

      // Destroys all commands!
      screen.destroyCommands = function(dontAnimate)
      {
        var destroyed = false;

        // Destroy the commands!
        for (var i = 0; i < screen.commands.length; i++)
        {
          var command = screen.commands[i];

          if ( command )
          {
            command.destroy( dontAnimate ); 
            destroyed = true;

            screen.commands[i] = null;
          }
        }

        if ( destroyed )
        {
          SoundEngine.play( 'com-2' ); 
        }
      };

      // Places a path marker at the given cell
      screen.placePathMarker = function(column, row, delay)
      {
        var marker = screen._pathMarker.clone();
        screen.placeItem( marker, column, row );
        marker.insertAfter( screen._pathMarker );
        marker.removeAttr( 'anim8' );
        marker.addClass('placedMarker');
        marker.removeClass('hidden');
        marker.removeAttr('data-named');
        marker.play('zoomIn 0.5s ~' + delay);
        marker.applyInitialState();
        return marker;
      };

      // Places an obstacle based on a definition
      screen.placeObstacle = function(obstacle)
      {
        var template = screen.sprite( screen.resolve( obstacle.template ) );
        var obs = template.clone();
        screen.placeItem( obs, screen.resolve( obstacle.column ), screen.resolve( obstacle.row ) );
        obs.insertAfter( template );
        obs.removeAttr( 'anim8' );
        obs.addClass( 'obstacle' );
        obs.removeClass( 'hidden' );
        obs.removeAttr( 'data-named' );
        obs.play( 'fadeIn 0.5s' );
        obs.applyInitialState();
        obs.animators().set({
          rotate: screen.resolve( obstacle.rotate || 0 )
        });
        return obs;
      };

      // Places an obstacle based on a definition
      screen.placeTarget = function(target)
      {
        var template = screen.sprite( screen.resolve( target.template ) );
        var tar = template.clone();
        screen.placeItem( tar, screen.resolve( target.column ), screen.resolve( target.row ) );
        tar.insertAfter( template );
        tar.removeAttr( 'anim8' );
        tar.addClass( 'target' );
        tar.removeClass( 'hidden' );
        tar.removeAttr('data-named');
        tar.play( 'fadeIn 0.5s' );
        tar.applyInitialState();
        tar.animators().set({
          rotate: screen.resolve( target.rotate || 0 )
        });
        return tar;
      };
      
      // Adds a highlight over the given command
      screen.addHighlight = function(command, index, delay, duration)
      {
        var highlight = command.highlight;
        var highlightAnimator = highlight.animators();
        var actualDelay = (delay - highlight.highlightDelay);

        highlightAnimator.queue({
          keyframe: {
            '0': {
              opacity: 0,
              translateX: screen.commandSeparation / screen.commandWidth * 100 * index
            },
            '20': {
              opacity: 1
            },
            '80': {
              opacity: 1
            },
            '100': {
              opacity: 0,
              translateX: screen.commandSeparation / screen.commandWidth * 100 * index
            }
          },
          units: {
            translateX: '%'
          }
        }, {
          delay: actualDelay,
          duration: duration
        });

        highlight.highlightDelay = delay + duration;
      };

      // Initialize a highlight before play
      screen.initHighlight = function(hl)
      {
        hl.highlightDelay = 0;
        hl.removeClass('hidden');
        hl.css({
          zIndex: 200,
          opacity: 0
        });
      };

      // Resolves a variable constant
      screen.resolve = function(x)
      {
        return typeof x === 'function' ? x() : x;
      };

      // Sets up the current wave variation for another try
      screen.setupRetry = function()
      {
        var waveArray = screen.waves[ screen.currentWave ];
        var wave = waveArray[ screen.currentWaveVariation ];

        // Position & Orient Robot
        if ( wave.start )
        {
          screen.placeItem( screen._robot, wave.start.column, wave.start.row );
          screen._robot
            .setAttributes({
              rotate: wave.start.rotation
            })
          ;          
        }

        // Hide Path Markers
        if ( !wave.keepPathMarkers )
        {
          screen.outroduceMany( screen.view.find('.placedMarker'), 'fadeOut 0.5s', function()
          {
            this.remove();
          }); 
        }

        // Move Highlights Behind
        screen._leftHighlight.css('zIndex', 1);
        screen._rightHighlight.css('zIndex', 1);
        screen._forwardHighlight.css('zIndex', 1);
      };

      // Sets up the screen for the current wave.
      screen.setupWave = function()
      {
        var waveArray = screen.waves[ screen.currentWave ];
        var variation = Math.floor( Math.random() * waveArray.length );
        var wave = waveArray[ variation ];

        // Hide Obstacles
        if ( !wave.keepObstacles )
        {
          screen.outroduceMany( screen.view.find('.obstacle'), 'fadeOut 0.5s', function()
          {
            this.remove();
          }); 
        }

        // Hide Targets
        if ( !wave.keepTargets )
        {
          screen.outroduceMany( screen.view.find('.target'), 'fadeOut 0.5s', function()
          {
            this.remove();
          }); 
        }

        // Position Target
        if ( wave.target )
        {
          screen.placeTarget( wave.target ); 
        }

        // Place Obstacles
        if ( wave.obstacles )
        {
          for (var i = 0; i < wave.obstacles.length; i++)
          {
            screen.placeObstacle( wave.obstacles[ i ] );
          } 
        }

        // Set the variation
        screen.currentWaveVariation = variation;

        // Finish setup
        screen.setupRetry();
      };
    }

  };

  return CommonFunctions;
});